<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Feed Bundle</ng-container>

    <ng-container dialog-process-in-progress
                  *ngIf="form && form.formGroup">
        <form [formGroup]="form.formGroup" class="row edit-feed-form">
            <div class="col-12">
                <span class="value  feed-subtitle">Available feeds</span>
            </div>

            <div class="col-12 pr-0 pl-0  feed-list">
                <div class="col-12 pr-0 pl-0" *ngFor="let feed of form.controls, let i = index">
                    <div *ngIf="i>form.FORM_ELEMENT_CCOUNT" class="d-flex align-items-center justify-content-between">
                        <p class="mb-0 col-6">
                            <app-checkbox
                                [control]="feed"
                                [formControlName]="feed.name"
                            >
                                <ng-container text>{{ getPlaceholderData(feed.placeholder,
                                    0) }}</ng-container>
                            </app-checkbox>
                        </p>
                        <p class="mb-0 col-2  bundle-price">{{ getPlaceholderData(feed.placeholder, 1) }}</p>
                        <p class="mb-0 col-2  bundle-price">{{ getPlaceholderData(feed.placeholder, 2) }}</p>
                        <p class="mb-0 col-2  bundle-price">{{ getPlaceholderData(feed.placeholder, 3).toUpperCase() }}</p>
                    </div>
                </div>
            </div> 
            <div class="col-12 pr-0 pl-0 mt-4" *ngIf="totals && totals.length > 0">
                <div class="row">
                    <div class="col-6">
                        <p class="mb-0 col-6"> Total Price : </p> 
                    </div>
                    <div class="col-6 align-items-center font-weight-bold justify-content-between">
                        <div class="row"  *ngFor="let item of totals">
                            <p class="mb-0 col-4">{{item.totalProPrice | formatDecimal}}</p>
                            <p class="mb-0 col-4">{{item.totalNonProPrice | formatDecimal}}</p>
                            <p class="mb-0 col-4">{{item.currency}}</p>
                        </div>
                       
                    </div>
                </div> 
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[0].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [formControlName]="form.controls[0].name"
                            [control]="form.controls[0]"
                        ></app-panel-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[1].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [formControlName]="form.controls[1].name"
                            [control]="form.controls[1]"
                        ></app-panel-input>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[2].errors?.length > 0}" class="col-6">
                        <app-select
                            [formControlName]="form.controls[2].name"
                            [control]="form.controls[2]"
                        ></app-select>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[3].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [formControlName]="form.controls[3].name"
                            [control]="form.controls[3]"
                        ></app-amount-input>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[4].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [formControlName]="form.controls[4].name"
                            [control]="form.controls[4]"
                        ></app-amount-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[5].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [formControlName]="form.controls[5].name"
                            [control]="form.controls[5]"
                        ></app-amount-input>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[6].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [formControlName]="form.controls[6].name"
                            [control]="form.controls[6]"
                        ></app-amount-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[7].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [formControlName]="form.controls[7].name"
                            [control]="form.controls[7]"
                        ></app-amount-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[8].errors?.length > 0}" class="col-6">
                        <app-select
                            [formControlName]="form.controls[8].name"
                            [control]="form.controls[8]"
                        ></app-select>
                    </div> 
                </div>
            </div>
        </form>
    </ng-container>

</app-dialog>
